import { t as throttle } from "./lodash-utils.js";
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function escapedStringToHtml(string) {
  return string.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#039;/g, "'");
}
function convertEscapedStringToHtml(str) {
  return str.replaceAll("&amp;", "&").replaceAll("&lt;", "<").replaceAll("&gt;", ">").replaceAll("&quot;", '"').replaceAll("&#039;", "'");
}
const iosAppHeight = () => {
  function iosHeightFix() {
    const doc = document.documentElement;
    doc.style.setProperty("--app-height", `${window.innerHeight}px`);
  }
  iosHeightFix();
  window.addEventListener("resize", throttle(iosHeightFix, 200));
};
const handleize = (value) => {
  return value.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, "");
};
function calculateMilliseconds(hours, mins = 0, seconds = 0) {
  return (hours * 60 * 60 + mins * 60 + seconds) * 1e3;
}
export {
  convertEscapedStringToHtml as a,
  calculateMilliseconds as c,
  debounce as d,
  escapedStringToHtml as e,
  handleize as h,
  iosAppHeight as i
};
